import multiRequest from '../shared/multiRequest';

function getPaymentMethod() {
  return multiRequest([
    {
      url: 'payment/paymentMethod',
      method: 'GET',
    },
  ]);
}

const payWithCard = data => {
  return multiRequest([
    {
      url: 'payment/wompay/paymentOneShot',
      method: 'POST',
      data,
    },
  ]);
};

const sendVoucherWompay = data => {
  return multiRequest([
    {
      url: 'payment/wompay/voucher',
      method: 'POST',
      data,
    },
  ]);
};

const deleteSubscribePaymentTdc = cardId => {
  return multiRequest([
    {
      url: `payment/wompay/card/${cardId}`,
      method: 'DELETE',
    },
  ]);
};

const activatePat = data => {
  return multiRequest([
    {
      url: `payment/wompay/activatePat`,
      method: 'POST',
      data,
    },
  ]);
};

const enrollCard = data => {
  return multiRequest([
    {
      url: 'payment/wompay/card',
      method: 'POST',
      data,
    },
  ]);
};

const updatePat = data => {
  return multiRequest([
    {
      url: `payment/wompay/updatePat`,
      method: 'PUT',
      data,
    },
  ]);
};

const removePat = () => {
  return multiRequest([
    {
      url: `payment/wompay/removePat`,
      method: 'DELETE',
    },
  ]);
};

const paymentOneShotBundle = data => {
  return multiRequest([
    {
      url: 'payment/wompay/paymentOneShotBundle',
      method: 'POST',
      data,
    },
  ]);
};

const paymentAgainstInvoiceBeneficiary = data => {
  return multiRequest([
    {
      url: 'marketplace/bundles/against-invoice/pay',
      method: 'POST',
      data,
    },
  ]);
};

const PaymentServices = {
  getPaymentMethod,
  payWithCard,
  sendVoucherWompay,
  deleteSubscribePaymentTdc,
  activatePat,
  updatePat,
  removePat,
  enrollCard,
  paymentOneShotBundle,
  paymentAgainstInvoiceBeneficiary,
};

export default PaymentServices;
